import styled from 'styled-components';
import { Modal, Input } from 'react-inv-forms';

import { variables } from '../../../styles/variables';

export const ChangeLogContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 15px;
  height: 300px;
  overflow: auto;
  position: relative;
`;

export const ChangeLogItem = styled.li`
  color: ${variables.colorMainText};
  opacity: 0.7;
  font-size: 1.8rem;
  padding: 3px 0;
`;

export const ChangeLogFormName = styled.strong`
  display: inline-block;

  &::first-letter {
    text-transform: capitalize;
  }
`;

export const NoDataInfo = styled(ChangeLogItem)`
  text-align: center;
`;

export const StyledModal = styled(Modal)`
  width: 650px;

  div.ant-modal-body {
    padding: 8px 24px;
  }

  div.ant-modal-title {
    span {
      color: ${variables.colorDecorator} !important;
    }
  }

  div.ant-modal-footer {
    display: none !important;
  }
`;

export const StyledInput = styled(Input)`
  border: 1px solid ${variables.colorWhite};
  border-radius: 0;
  padding: 0;

  &.ant-input-affix-wrapper:focus,
  &.ant-input-affix-wrapper-focused {
    border: 1px solid ${variables.colorWhite};
    box-shadow: none;
  }

  .ant-input-prefix {
    margin-right: 10px;
    color: ${variables.colorDecorator};
  }

  &:hover {
    border-color: ${variables.colorWhite};
    border-bottom-color: ${variables.colorDecorator};
  }
`;
